export default {
  // 해당 프레임워크가 사용될 시스템 이름
  // 특정 타입 템플릿에서 상단에 출력됨
  name: '',
  // 개발하고 있는 서비스의 고유 ID 값
  // request 해더 및 Log 생성 시, 사용 된다.
  systemId: 'HIWAY4VUETIFY',
  // request 해더에 사용되는 API 버전 기본 정보
  // api 조회 간 meta 값에 apiVersion 정보가 있을 경우, meta값을 우선으로 한다.
  apiVersion: 'v1.0',
  // local 개발환경에서 작업 시, restful mockup 서버 url 정보
  // 차후, 개발 서버가 구축되면 그곳으로 변경
  // devUrl: 'http://10.100.16.66/hiway',
  // devUrl: 'http://10.100.16.66/hiway',
  //   devUrl: 'http://localhost:8080',
  devUrl: '/',
  // 서버 (개발, 운영) 환경에 build하여 업로드 할 경우, 기본 api base url
  buildUrl: '/hismart',
  framework: {
    // 상세 로그 출력 여부
    showDetailLog: false,
    // local 개발환경에서 작업 시, restful api 서버를 사용 여부
    // false일 경우 mockup으로 framework에서 제공되는 기본 셋을 사용
    useRestfulAPI: true,
    // API 등 Error 발생 시, Global 하게 출력할 에러 팝업 내에서 메시지 형식을 리스트 형식으로 사용 여부
    useErrorList: false,
    // 빌드된 이후에도 mockup을 사용할 경우 true로 셋팅
    // useRestfulAPI 보다 더 상위. useRestfulAPI값이 true여도 이 값이 true 면 무시된다.
    onlyMockup: false,
    // framework에서는 지원하는 locale형식을 작성해야 한다.
    // 이 값을 각 Locale의 ID로 하며, 서버 조회 및 분기를 한다.
    supportLocales: [
      {
        id: 'ko',
        name: '한국어'
      },
      {
        id: 'en',
        name: 'English'
      }
    ],
    // 서버에서 i18n 데이터를 가져와 적용할 것인가 설정하는 부분
    // true일 경우 서버를 조회하는 로직이 수행되고, false일 경우 서버를 조회하지 않고 local의 기본 값을 사용한다.
    getI18nDataFromServer: true,
    template: {
      home: 'MN00343',
      useMobile: true
    },
    // login 하지 않아도 접근이 가능한 URL 항목 리스트
    whiteList: [
      '/phoneCertificate',
      '/regist',
      '/login',
      '/mobile/login',
      '/mypage',
      '/not-found',
      '/sso',
      '/forbidden',
      '/personalInfoPrcessPopup',
      '/test-token',
      '/example/echartd',
      '/example/table',
      '/blank',
      '/findidpw',
      // '/privacyInfo',
      '/example/window-popup'
      // ,'/VideoInformationPolicy'
    ],
    // 모바일 url 리스트
    mobileList: []
  },
  WowzaAddress: 'https://5db54771c2620.streamlock.net:1935',
  WowzaMgIpAddress:
    'https://5db54771c2620.streamlock.net:8087/v2/servers/_defaultServer_/vhosts/_defaultVHost_/applications/live'
}
